"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCatTags = getCatTags;

var _request = _interopRequireDefault(require("@/utils/request"));

function getCatTags() {
  return (0, _request.default)({
    url: '/cat-tags/list',
    method: 'get'
  });
}